export const LiferayLoginConfig62 = {
  LOGIN_ACTION:
    'web/guest/login?p_p_id=smilesloginportlet_WAR_smilesloginportlet&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_resource_id=createSessionAuth',
  IS_LOGGED_ACTION:
    'web/guest/login?p_p_id=smilesloginportlet_WAR_smilesloginportlet&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_resource_id=isLoggedAuth',
  SESSION_CREATED: 200,
};
